import { z } from 'zod'

/**
 * What `GET /me` returns. Deliberately does NOT expose `litellmUserKey` — in V1
 * that key was shipped to the browser and could create and delete API keys.
 */
export const userProfileSchema = z.object({
  id: z.string(),
  email: z.email(),
  name: z.string(),
  avatarUrl: z.string().nullable(),
  createdAt: z.string(),
  /** False until the user has a LiteLLM account; the API provisions one on demand. */
  isProvisioned: z.boolean(),
  /**
   * Comes from the server-side email allowlist. The dashboard uses it to offer
   * the admin panel and the toggle back to the normal user view.
   */
  isSuperAdmin: z.boolean(),
})

export type UserProfile = z.infer<typeof userProfileSchema>
